export enum AsyncStatus {
  Idle = 'idle',
  Loading = 'loading',
  Success = 'success',
  Failed = 'failed',
}

export type Unpacked<T> = T extends (infer U)[] ? U : T;
